import React from 'react';
import { motion } from 'framer-motion';
import { getAvatarStyle } from '@/utils/avatarUtils';

export const Avatar = ({ username, size = 'md', className = '' }) => {
  const sizeClasses = {
    sm: 'w-8 h-8 text-xs',
    md: 'w-10 h-10 text-sm',
    lg: 'w-12 h-12 text-base',
    xl: 'w-20 h-20 text-2xl',
  };

  const avatarStyle = getAvatarStyle(username);

  return (
    <motion.div
      whileHover={{ scale: 1.05 }}
      className={`${sizeClasses[size]} flex items-center justify-center font-bold shadow-soft flex-shrink-0 ${className}`}
      style={avatarStyle}
    >
      {username?.charAt(0).toUpperCase()}
    </motion.div>
  );
};
